import { BaseComponent } from '../../base-component';
import { wishlist } from '@otto-ec/nexus-registry/wishlist';

export class WishlistBtnComponent extends BaseComponent {
    public rootSelector = '.js_pdp_wishlist-btn';

    public async init(): Promise<void> {
        return;
    }

    protected getRootElement<T extends HTMLElement>(): T {
        /*                                                                                                             */
        const allElements = document.querySelectorAll<HTMLElement>(this.rootSelector);
        const visibleElement = Array.from(allElements).find(el => !el.closest('.pl_hidden'));
        return (visibleElement || allElements[0]) as unknown as T;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) return;

        this.getButtonElement().addEventListener('click', () => this.handleButtonClickEvent());
        this.getWishlistLink()?.addEventListener('click', () => (window.location.href = '/wishlist-view/'));
        this.getAppLink()?.addEventListener(
            'click',
            () =>
                (window.location.href =
                    'https:/*                                                                                                                                                                                                                                                                                                                 */
        );
    }

    public handleButtonClickEvent(): void {
        const variationId = this.getButtonElement().dataset.variationId;
        if (variationId) {
            this.addToWishlist(variationId);
            this.showMessage();
            this.setWishlistButtonToActiveState();
        }
    }

    public addToWishlist(variationId: string): void {
        wishlist.addItem(variationId, true, 'ProductDetailPage').catch(error => {
            Logger.logError('Failed to add item to wishlist:', error);
        });
    }

    private setWishlistButtonToActiveState(): void {
        const iconUseElement = this.getButtonElement();
        if (!iconUseElement) return;

        iconUseElement.setAttribute('icon-type-left', 'wishlist-active');
    }

    private showMessage(): void {
        o_global.eventQBus.emit('assets.snackbar.trigger', {
            text: 'Gespeichert!',
            actionLinkText: 'Merkzettel anzeigen',
            actionFunction: () => {
                window.location.href = '/wishlist-view/';
            },
        });
    }

    private getButtonElement(): HTMLButtonElement {
        return this.getChildElement('.js_pdp_wishlist-btn__button') as HTMLButtonElement;
    }

    private getWishlistLink(): HTMLLinkElement | null {
        try {
            return this.getChildElement('.js_pdp_wishlist-link') as HTMLLinkElement;
        } catch {
            return null;
        }
    }

    private getAppLink(): HTMLLinkElement | null {
        try {
            return this.getChildElement('.js_pdp_app-link') as HTMLLinkElement;
        } catch {
            return null;
        }
    }
}
